var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup", staticStyle: { zIndex: "200" } }, [
        _c(
          "div",
          {
            staticClass: "content",
            class: _vm.isSuccess ? "license-success" : "",
            attrs: { id: "licenseCode" }
          },
          [
            _c("div", { staticClass: "title" }, [
              !_vm.isSuccess
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.license.codeTitle")))
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.license.codeSucTitle")))
                  ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.isShow = false
                  }
                }
              })
            ]),
            _vm._v(" "),
            !_vm.isSuccess
              ? _c("div", { staticClass: "personInfo-content" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../assets/images/workspace/license_key.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("language.license.codeTipTitle")))
                  ]),
                  _vm._v(" "),
                  _vm.user.vip
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            cursor: "context-menu",
                            color: "#333333"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.license.codeTipTextVip"))
                          )
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            cursor: "context-menu",
                            color: "#333333"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("language.license.codeTipText")))]
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "license-function" },
                    [
                      _c("el-input", {
                        staticClass: "license-input",
                        class: _vm.isCodeError ? "error" : "",
                        on: { input: _vm.changeLicenseCode },
                        model: {
                          value: _vm.code,
                          callback: function($$v) {
                            _vm.code = $$v
                          },
                          expression: "code"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.isLoading,
                              expression: "isLoading"
                            }
                          ],
                          on: { click: _vm.checkLicenseCode }
                        },
                        [
                          !_vm.isLoading
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$t("language.common.ok")))
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isCodeError
                        ? _c("span", { staticClass: "license-input-error" }, [
                            _vm._v(_vm._s(_vm.errorText))
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "license-footer" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("language.license.codeFooter"))
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: "mailto:support@multcloud.com" } },
                      [_vm._v("support@multcloud.com")]
                    )
                  ])
                ])
              : _c(
                  "div",
                  { staticClass: "personInfo-content" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/images/workspace/license_success.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "strong",
                      { staticStyle: { flex: "1", "margin-top": "10px" } },
                      [_vm._v(_vm._s(_vm.$t("language.license.codeSucTip")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "license-success-btn",
                        on: {
                          click: function($event) {
                            _vm.isShow = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                    )
                  ],
                  1
                )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59671a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59671a92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/license_code_popup.vue
// module id = null
// module chunks = 